import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const FORWARD: AppRouteRecordRaw = {
  path: '/forward',
  name: 'forward',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '平台管理',
    requiresAuth: true,
    icon: 'icon-settings',
    order: 3,
  },
  children: [
    {
      path: '/platform',
      name: 'Platform',
      component: () => import('@/views/platform/index.vue'),
      meta: {
        locale: '三方平台列表',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'server',
      name: 'Server',
      component: () => import('@/views/forward/server/index.vue'),
      meta: {
        locale: '服务器管理',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'log',
      name: 'ForwardLog',
      component: () => import('@/views/station/device/forward-log.vue'),
      meta: {
        locale: '转发日志',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default FORWARD;
